import { _ } from '../translations/translate-helper';

export const PaymentMethodDict = {
    bank_transfer: _('cart|Bank transfer'),
    cash_on_delivery: _('cart|Cash on delivery'),
    heidelpay: _('cart|Unzer'),
    payu: _('cart|PayU'),
}
